/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentRetryInput = {|
  cc?: ?InputCreditCard,
  paymentMethod: string,
  salesOrderId: string,
|};
export type InputCreditCard = {|
  ccCvv: string,
  ccMonth: string,
  ccNumber: string,
  ccOwner: string,
  ccType: string,
  ccYear: string,
|};
export type PaymentRetryMutationVariables = {|
  input: PaymentRetryInput
|};
export type PaymentRetryMutationResponse = {|
  +createOrder: ?{|
    +salesOrder: ?{|
      +id: string,
      +encryptedId: ?string,
      +name: ?string,
      +verified: ?number,
      +grandTotal: ?number,
      +shippingTotal: ?number,
      +paymentMethod: ?string,
      +status: ?number,
      +lines: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
            +quantity: ?number,
            +unitPrice: ?number,
            +rowTotal: ?number,
            +product: ?{|
              +id: string,
              +sku: ?string,
              +name: ?string,
              +brand: ?{|
                +id: string,
                +name: ?string,
              |},
            |},
            +children: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +name: ?string,
                  +quantity: ?number,
                  +unitPrice: ?number,
                  +product: ?{|
                    +id: string,
                    +sku: ?string,
                  |},
                |}
              |}>
            |},
          |}
        |}>
      |},
    |}
  |}
|};
export type PaymentRetryMutation = {|
  variables: PaymentRetryMutationVariables,
  response: PaymentRetryMutationResponse,
|};
*/


/*
mutation PaymentRetryMutation(
  $input: PaymentRetryInput!
) {
  createOrder: paymentRetry(input: $input) {
    salesOrder {
      id
      encryptedId
      name
      verified
      grandTotal
      shippingTotal
      paymentMethod
      status
      lines(first: 99) {
        edges {
          node {
            id
            name
            quantity
            unitPrice
            rowTotal
            product {
              id
              sku
              name
              brand {
                id
                name
              }
            }
            children(first: 99) {
              edges {
                node {
                  id
                  name
                  quantity
                  unitPrice
                  product {
                    id
                    sku
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitPrice",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sku",
  "storageKey": null
},
v7 = [
  {
    "alias": "createOrder",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PaymentRetryPayload",
    "kind": "LinkedField",
    "name": "paymentRetry",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SalesOrder",
        "kind": "LinkedField",
        "name": "salesOrder",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "encryptedId",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "verified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "grandTotal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shippingTotal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentMethod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SalesOrderLineConnection",
            "kind": "LinkedField",
            "name": "lines",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesOrderLineEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesOrderLine",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rowTotal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v6/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Brand",
                            "kind": "LinkedField",
                            "name": "brand",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v3/*: any*/),
                        "concreteType": "SalesOrderLineConnection",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SalesOrderLineEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SalesOrderLine",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "product",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "children(first:99)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "lines(first:99)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentRetryMutation",
    "selections": (v7/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentRetryMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "b221aabd8d39b831e0da5e001fb2dd6a",
    "id": null,
    "metadata": {},
    "name": "PaymentRetryMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentRetryMutation(\n  $input: PaymentRetryInput!\n) {\n  createOrder: paymentRetry(input: $input) {\n    salesOrder {\n      id\n      encryptedId\n      name\n      verified\n      grandTotal\n      shippingTotal\n      paymentMethod\n      status\n      lines(first: 99) {\n        edges {\n          node {\n            id\n            name\n            quantity\n            unitPrice\n            rowTotal\n            product {\n              id\n              sku\n              name\n              brand {\n                id\n                name\n              }\n            }\n            children(first: 99) {\n              edges {\n                node {\n                  id\n                  name\n                  quantity\n                  unitPrice\n                  product {\n                    id\n                    sku\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd6457162672e880c469d51ee1bd33844';

module.exports = node;
